import { gate } from 'hub-http/gates';
export const ADVANCED_ADD_DATA_SOURCE = 'Workflows:AddDataSourceAdvanced';
export const ENFORCE_FIELD_LEVEL_PERMISSIONS = 'Automation:EnforceFieldLevelPermissions';
export const SUPPORT_SELECTING_SENSITIVE_PROPERTIES = gate('Automation:SupportSelectingSensitiveProperties');
export const PROPERTY_MATCHING_DATA_SOURCES = gate('Workflows:PropertyMatchingDataSources');
export const TEXT_INPUT_LLM_HELPER = gate('Automation:TextInputLLMHelper');
export const MULTI_OBJECT_DATA_SOURCES = gate('Workflows:MultiObjectDataSources');